<template>
  <div>
    <!-- TODO: refactor markup Header Component-->
    <b-navbar variant="light" type="light" fixed="top" toggleable="lg" class="navbar-default shadow p-0 d-block">
      <b-container fluid class="pr-0">
        <b-navbar-brand href="#" class="p-0">
          <img src="@/assets/images/logos/logo-hello.png" alt="logo"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="px-2 px-sm-0">
          <mainMenu></mainMenu>
          <b-navbar-nav class="ml-auto mt-3 mt-sm-0 nav-user">
            <userInformation class="nav-user ml-sm-auto"/>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

  </div>
</template>

<script>
import mainMenu from './main_menu'
import userInformation from './user_informations.vue'

export default {
  name: 'privateHeader',
  components: { mainMenu, userInformation }
}
</script>
